import { Component, OnInit } from '@angular/core';
import {ListeParution} from '../../../../../../model/liste/ListeParution';
import {ActivatedRoute, Router} from '@angular/router';
import {DialogueShareService} from '../../../../../../service/partage/utilitaire/DialogueShareService';
import {NgxSpinnerService} from 'ngx-spinner';
import {ListeParutionService} from '../../../../../../service/interne/parution/ListeParutionService';
import {Environement} from '../../../../../../environement/environement';
import {ParutionService} from '../../../../../../service/interne/parution/parutionService';
import {Parution} from '../../../../../../model/parution/Parution';

@Component({
  selector: 'app-escal-liste-parution-fiche-pressbook',
  templateUrl: './escal-liste-parution-fiche-pressbook.component.html',
  styleUrls: ['./escal-liste-parution-fiche-pressbook.component.scss'],
  providers: [ ListeParutionService, ParutionService ]
})
export class EscalListeParutionFichePressbookComponent implements OnInit {

  id: number;
  sub: any;
  listeParution: ListeParution;
  optionPolice: Array<number>;
  policeChose: number;
  inclureNomParution: boolean;
  trierClient: boolean;
  trierTypeParution: boolean;
  trierTypeRetombee: boolean;
  trierTypeAnnonce: boolean;
  trierTheme: boolean;
  trierLogoSupport: boolean;
  isClient = true;
  orderDateCroissant = true;
  repriseCp = false;
  erreurs;
  couleur = false;
  couleurAgence = '#000000';
  couleurAudiovisuel = '#000000';
  couleurPrint = '#000000';
  couleurOnline = '#000000';
  linkSommaire = false;
  linkPressBook = false;
  parutions: Array<Parution>;
  typeRetombee: Array<any>;
  listeTypeRetombee: Array<any>;
  theme: Array<any>;
  listeTheme: Array<any>;
  dateDebut: string;
  dateFin: string;

  listeTypeParution = [
    {
      content: 'Agence de presse',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Audiovisuel',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Print',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Online',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
  ];

  listeTypeAnnonce = [
    {
      content: 'Institutionnel',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Produit',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Corporate',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Expertise Marché',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Sociétal',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
  ];

  listeLogoSupport = [
    {
      content: 'TV',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Radio',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Print',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
    {
      content: 'Online',
      effectAllowed: 'move',
      disable: false,
      handle: false,
    },
  ];
  constructor(private route: ActivatedRoute, private dialogueShareService: DialogueShareService, private spinner: NgxSpinnerService,
              private listeParutionService: ListeParutionService, private parutionService: ParutionService, private router: Router) { }

  ngOnInit() {
    this.erreurs = [];
    this.optionPolice = [];
    this.optionPolice.push(8);
    this.optionPolice.push(9);
    this.optionPolice.push(10);
    this.optionPolice.push(11);
    this.optionPolice.push(12);
    this.optionPolice.push(13);
    this.optionPolice.push(14);
    this.optionPolice.push(18);
    this.optionPolice.push(24);
    this.optionPolice.push(32);
    this.policeChose = 10;
    this.trierClient = false;
    this.inclureNomParution = false;
    this.trierTypeParution = false;
    this.trierTypeRetombee = false;
    this.trierTypeAnnonce = false;
    this.trierTheme = false;
    this.trierLogoSupport = false;
    this.sub = this.route.params.subscribe(params => {
      this.listeParutionService.getListeParutionDetails(params.id)
        .then((listeParution) => {
          this.listeParution = listeParution as ListeParution;
          this.id = this.listeParution.ancienId;
          if (this.listeParution.client != null) {
            this.isClient = true;
          } else {
            this.isClient = false;
          }
          this.initLink();
          this.listeTypeRetombee = [];
          this.listeTheme = [];
          this.listeParutionService.getParutionsListeAssociees(params.id).then((parutionsListe) => {
            this.parutions = parutionsListe['hydra:member'] as Array<Parution>;
            let typePresent;
            let themePresent;
            let typeRetombee;
            let typeTheme;
            this.parutions.forEach(parution => {
              typeRetombee = { content: parution.typeRetombee.libelle, effectAllowed: 'move', disabled: false, handle: false};
              typePresent = this.listeTypeRetombee.find((type) => type.content === parution.typeRetombee.libelle);
              if (typePresent === undefined) {
                this.listeTypeRetombee.push(typeRetombee);
              }
            });
            this.parutions.forEach(parution => {
              typeTheme = { content: parution.theme.libelle, effectAllowed: 'move', disabled: false, handle: false};
              themePresent = this.listeTheme.find((theme) => theme.content === parution.theme.libelle);
              if (themePresent === undefined) {
                this.listeTheme.push(typeTheme);
              }
            });
            let dateDeb = parutionsListe['hydra:member'][0].date;
            let dateFin = parutionsListe['hydra:member'][0].date;
            this.parutions.forEach(parution => {
              if (parution.date < dateDeb) {
                dateDeb = parution.date;
              }
              if (parution.date >= dateFin) {
                dateFin = parution.date;
              }
            });
            this.dateDebut = dateDeb.substr(0, 10);
            this.dateFin = dateFin.substr(0, 10);
            console.log(this.dateDebut);
            console.log(this.dateFin);
          });
        });
    });
  }

  initLink() {
    this.parutionService.getPressBookGenerer(this.id)
      .then((retour) => {
        if (retour['generer'] === 'false') {
          this.linkSommaire = false;
          this.linkPressBook = false;
        } else {
          this.linkSommaire = true;
          this.linkPressBook = true;
        }
      });
  }

  genererPressbook() {
    this.erreurs = [];
    this.spinner.show();
    this.parutionService.genererSommaireEscalnet(this.id, this.policeChose, this.trierClient, this.trierTypeParution,
      this.inclureNomParution, this.listeTypeParution, this.repriseCp, this.orderDateCroissant, this.couleur, this.couleurPrint,
      this.couleurAudiovisuel, this.couleurOnline, this.couleurAgence, this.trierLogoSupport, this.listeLogoSupport, this.trierTypeRetombee,
      this.listeTypeRetombee, this.trierTypeAnnonce, this.listeTypeAnnonce, this.trierTheme, this.listeTheme, this.dateDebut, this.dateFin)
      .then((retour) => {
        this.spinner.hide();
        if (typeof (retour['type']) !== 'undefined'){
          this.initLink();
          this.erreurs = retour['erreurs'];
        } else {
          this.parutionService.getPressBookGenerer(this.id)
            .then((retour1) => {
              window.location.reload();
            });
        }
      });
  }


  genererLinkPressBook(){
    const rand1 = Math.floor(Math.random() * Math.floor(1000000));
    const rand2 = Math.floor(Math.random() * Math.floor(1000000));
    return Environement.BASE_API_URL + '/sommaire/' + this.id + 'pressbook.pdf?' + rand1 + '=' + rand2;
  }
  genererLinkSommaire(){
    const rand1 = Math.floor(Math.random() * Math.floor(1000000));
    const rand2 = Math.floor(Math.random() * Math.floor(1000000));
    return Environement.BASE_API_URL + '/sommaire/' + this.id + 'sommaire.docx?' + rand1 + '=' + rand2;
  }

  afficherParution(parutionAncienId) {
    // récupérer l'id escalnet de la parution si existe
    this.parutionService.getParutionByAncienId(parutionAncienId).then(retour => {
      if (retour['hydra:member'][0] != null && retour['hydra:member'][0] != undefined) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree([`/escal/parution/${retour['hydra:member'][0].id}`])
        );
        window.open(url, '_blank');
      } else {
        const url = 'http://intranet.escalconsulting.com/parution_cms.php?action=vuedetail&parution_ID=' + parutionAncienId;
        window.open(url, '_blank');
      }
    });
  }

  verifCheck(type) {
    if (type === 'typeParution') {
      this.trierTypeRetombee = false;
      this.trierTypeAnnonce = false;
      this.trierTheme = false;
    }
    if (type === 'typeRetombee') {
      this.trierTypeParution = false;
      this.trierTypeAnnonce = false;
      this.trierTheme = false;
    }
    if (type === 'typeAnnonce') {
      this.trierTypeParution = false;
      this.trierTypeRetombee = false;
      this.trierTheme = false;
    }
    if (type === 'theme') {
      this.trierTypeParution = false;
      this.trierTypeRetombee = false;
      this.trierTypeAnnonce = false;
    }
  }

}
